
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'
export default {
    name: 'NewYorkClosing',
    components: { BlogTextColor },
}
